// Communication — Détail SMS (envoyés / non envoyés (essai) / échoués / total).
import { useEffect, useState } from "react";
import { MessageCircle, Send, Inbox, CheckCircle, AlertTriangle, Loader2 } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => {
  const t = localStorage.getItem("session_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

function MiniStat({ icon: Icon, label, value, color }) {
  return (
    <div className="flex items-center gap-3 p-3 rounded-lg"
      style={{ background: "var(--oh-bg-surface)" }}>
      <div className="w-9 h-9 rounded-lg flex items-center justify-center"
        style={{ backgroundColor: `color-mix(in srgb, ${color} 14%, transparent)`, color }}>
        <Icon className="w-4 h-4" />
      </div>
      <div>
        <p className="text-xs" style={{ color: "var(--oh-text-muted)" }}>{label}</p>
        <p className="text-lg font-bold" style={{ color: "var(--oh-text)" }}>{value}</p>
      </div>
    </div>
  );
}

export default function CommunicationSMSWidget() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/api/communication/stats?channel=sms`, { headers: auth() });
        if (!cancelled) setStats(r.data || {});
      } catch { if (!cancelled) setStats({}); }
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading) return <div className="rounded-xl p-5 flex items-center justify-center"
    style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
    <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} /></div>;

  return (
    <div className="rounded-xl p-5" style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="communication-sms-widget">
      <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: "var(--oh-text)" }}>
        <MessageCircle className="w-4 h-4" style={{ color: "var(--oh-stat-amber-text)" }} />
        SMS
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <MiniStat icon={Send} label="Envoyés" value={stats.sent || 0} color="var(--oh-stat-green-text)" />
        <MiniStat icon={Inbox} label="Non envoyés (mode essai)" value={stats.simulated || 0} color="var(--oh-stat-amber-text)" />
        <MiniStat icon={AlertTriangle} label="Échoués" value={stats.failed || 0} color="var(--oh-stat-red-text)" />
        <MiniStat icon={CheckCircle} label="Total" value={stats.total || 0} color="var(--oh-stat-blue-text)" />
      </div>
    </div>
  );
}
